export const calculateAttachRateMeasureGDP = (column: any) => {
  const keys =[
  'GDPFinalActToGoTotalAttachRatePct',
  'GDPToGoTotalFcst',
  'HeroGDPActToGoTotalFcst'
];
keys.forEach((key) => {
  if (column['measures'][key] !== 'Multiple %') {
    column['measures'][key] = +(column['measures'][key] || 0)
      .toString()
      .replaceAll(',', '');
  }
});
if (column['measures']['HeroGDPActToGoTotalFcst'] == 0) {
  column['measures']['GDPFinalActToGoTotalAttachRatePct'] = 0;
  return;
}
  column['measures']['GDPFinalActToGoTotalAttachRatePct'] = column['measures']['GDPToGoTotalFcst'] / column['measures']['HeroGDPActToGoTotalFcst'] * 100
  if (column['measures']['GDPFinalActToGoTotalAttachRatePct'] !== 'Multiple %') {
    column['measures']['GDPFinalActToGoTotalAttachRatePct'] = column['measures']['GDPFinalActToGoTotalAttachRatePct']
      .toString()
      .replaceAll('%', '');
    column['measures']['GDPFinalActToGoTotalAttachRatePct'] = column['measures']['GDPFinalActToGoTotalAttachRatePct'];
  }
}
